import Vue from 'vue'
import * as Sentry from '@sentry/vue'

try {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      Vue,
      dsn: 'https://586d92671d528c730aa8c8a4c29b5231@sentry.eeeoeee.com/12',
      release: window.__NUXT__.config.CI_COMMIT_ID,
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: [
            'localhost',
            /^https:\/\/yourserver\.io\/api/
          ]
        }),
        new Sentry.Replay({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
    Vue.use(Sentry)
  }
} catch (err) {
  console.log(err, 222)
}
